<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
								<p>{{translate(locale.profileImage)}}</p><br>
								<loading v-if="uploading"/>
								<img v-if="!uploading && String(profile.image_logo_url).length > 12" :src="config.cdn + 'images/' + profile.image_logo_url" style="width: 180px; height:180px; border-radius: 50%; border: 1px solid #BBB;" alt=""><br>
								<md-button class="md-raised md-primary" @click="$refs.file.click()">{{translate(locale.uploadNewLogo)}}</md-button>
								<input type="file" ref="file" accept="image/*" @change="handleFile($event)" style="display: none" />
							</div>

							<div class="md-layout-item md-small-size-100 md-size-100 text-right">
								<span class="late">{{translate(locale.required)}}</span>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>{{translate(locale.generalInformation)}}</h4>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-40">
								<form-input v-model="profile.name" :label="locale.profileName"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-30">
								<form-select v-model="profile.profile_type_id" :list="profile_type_list" :label="locale.profileType"/>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<form-select v-model="profile.established_year" :list="established_year_list" :label="locale.establishedYear"/>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<form-input type="number" v-model="profile.total_staff" :label="locale.totalStaff"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<form-textarea v-model="profile.description" :label="locale.profileDescription" height="100"/>
								<p class="text-right" style="color: #999; font-size: 12px">{{String(profile.description).length}} {{translate("characters||តួអក្សរ")}}</p>
							</div>
							
							<div class="md-layout-item md-small-size-100 md-size-100">
								<label>{{translate(locale.profileSector)}}</label>
								<v-select label="name" inputId="id" :clearable="false" :options="profile_sub_sector_list" multiple
									v-model="profile.sub_sector">
								</v-select>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>{{translate(locale.contactInformation)}}</h4>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-25">
								<form-select v-model="profile.location_province_id" :list="province_list" :label="locale.addressProvince"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-25">
								<form-select v-model="profile.location_district_id" :list="district_filtered_list" :label="locale.addressDistrict"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">
								<form-input v-model="profile.address" :label="locale.fullAddress"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<form-input v-model="profile.phone" :label="locale.phoneNumber"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<form-input v-model="profile.email" :label="locale.email"/>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<form-input v-model="profile.website" :label="locale.website" :required="false"/>
							</div>
							<div class="md-layout-item md-size-100 text-right">
								<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
							</div>
							<div class="md-layout-item md-size-100 text-right">
								<md-button class="md-raised md-primary" @click="updateProfile()">{{translate(locale.updateProfile)}}</md-button>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>

		</div>
	</div>
</template>

<script>

	export default {
		components: {
		},
		created() {
			this.getSettings();

			let year = (new Date()).getFullYear();
			for(let i = year; i >= 2000; i--) {
				this.established_year_list.push({id: i, name: i});
			}
		},
		data() {
			return {
				loaded: false,
				profile_type_list: [],
				profile_sub_sector_list: [],
				established_year_list: [],
				province_list: [],
				district_list: [],
				district_filtered_list: [],
				profile: {
					image_logo_url: "",
					name: "",
					description: "",
					profile_type_id: "",
					established_year: "",
					total_staff: "",
					email: "",
					phone: "",
					address: "",
					website: "",
					location_district_id: "",
					location_province_id: "",
					sub_sector: []
				},
				content: "",
				uploading: false,
				errors: []
			}
		},
		watch: {
			'profile.location_province_id' : function(val) {
				this.district_filtered_list = [];
				this.profile.location_district_id = "";
				for(let i = 0; i< this.district_list.length; i++) {
					if(this.district_list[i].location_province_id == val) this.district_filtered_list.push(this.district_list[i]);
				}
			}
		},
		methods: {
			imageUploadHandler() {

			},
			getSettings() {
				this.$http.get(this.config.api + "/profile/setting/profile").then(data => {

					this.province_list = this.config.clearList(data.body.data.province, this.$store.state.l.lang);
					this.district_list = this.config.clearList(data.body.data.district, this.$store.state.l.lang);
					this.profile_type_list = this.config.translateList(data.body.data.profile_type, this.$store.state.l.lang); 
					this.profile_sub_sector_list = this.config.clearList(data.body.data.profile_sub_sector, this.$store.state.l.lang);

					this.getProfile();
				})
			},

			getProfile(more = false) {
				this.$http.get(this.config.api + "/profile/information/get_edit").then(data => {
					let profile = data.body.data.profile;
					let profile_sub_sector = data.body.data.profile_sub_sector;
					
					this.profile.image_logo_url = profile.image_logo_url;
					this.profile.name = profile.name;
					this.profile.description = profile.description;
					this.profile.total_staff = profile.total_staff;
					this.profile.established_year = profile.established_year;
					this.profile.website = profile.website;
					this.profile.phone = profile.phone;
					this.profile.email = profile.email;
					this.profile.address = profile.address;
					this.profile.profile_type_id = profile.profile_type_id;

					this.profile.location_province_id = profile.province_id;
					setTimeout(() => {
						this.profile.location_district_id = profile.district_id;
						
					}, 200);
					
					for(let i = 0; i<profile_sub_sector.length; i++) {
						this.profile.sub_sector.push({id: profile_sub_sector[i].id, name: this.translate(profile_sub_sector[i].name)});
					}
					
					this.loaded = true;
					
				})
			},

			updateProfile() {

				if(!this.checkValidation()) {
					this.$notification.notify({
						message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។",
						icon: 'error',
						type: 'danger'
					});
					return;
				}

				this.$http.post(this.config.api + "/profile/information/update", {
					profile: this.profile
				}).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({
							message: "You have updated your profile successfully.",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/my_profile");
					}
				})
			},

			handleFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.file.files[0]);
				this.uploading = true;
				this.$http.post(this.config.api + "/profile/upload/logo", formData).then(res => {
						this.uploading = false;
						if (res.body.status == 'success') {
							this.profile.image_logo_url = res.body.data.image_hash;
						}
					})
			},

			checkValidation() {
				this.errors = [];

				if(String(this.profile.name).length < 5) this.errors.push("Profile Name is too short.");
				if(String(this.profile.profile_type_id).length == 0) this.errors.push("Profile Type is not selected.");
				if(String(this.profile.established_year).length == 0) this.errors.push("Established Year is not selected.");
				if(parseInt(this.profile.total_staff) <= 0) this.errors.push("Total Staff is invalid.");
				if(String(this.profile.description).length < 100) this.errors.push("Profile Description is too short.");
				if(String(this.profile.description).length > 2000) this.errors.push("Profile Description is too long.");
				if(String(this.profile.location_district_id).length == 0) this.errors.push("Address District is not selected.");
				if(String(this.profile.address).length == 0) this.errors.push("Address is empty.");
				if(String(this.profile.phone).length == 0) this.errors.push("Phone Number is empty.");
				if(String(this.profile.email).length == 0) this.errors.push("Email is empty.");
				if(Array.isArray(this.profile.sub_sector) && this.profile.sub_sector.length == 0) this.errors.push("Profile Sector is empty.");

				if(this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/ProfileInformation.vue